/**
 * EUDI Wallet colour overlay: owned by the "EUDI Wallets" top-level tab. While
 * it is on, the globe keeps only countries that report an EUDI Wallet status
 * active, colors them by that status, and the map legend explains the scale.
 * The state lives on window.__EUDI_WALLET_FILTER__ so the globe and the table
 * filter (separate module scopes) can read it while coloring/filtering.
 *
 * This module only owns the state and the legend; the data-type toggle drives
 * it and re-renders the globe and table afterwards.
 */
export interface EudiOverlayApi {
  /** Turn the overlay + legend on or off. */
  setActive: (active: boolean) => void
}

export function initEudiOverlay(): EudiOverlayApi {
  const legend = document.getElementById('eudi-legend')

  return {
    setActive: function (active: boolean): void {
      window.__EUDI_WALLET_FILTER__ = active
      if (legend) legend.hidden = !active
    },
  }
}
